import { faCalendarDays, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  IconButton,
  Skeleton,
  styled,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import calendericon from "../../assets/auth/calendericon.svg";

import React, { useState, useEffect, useRef } from "react";
import DoneIcon from "@mui/icons-material/Done";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import api from "../../api/api";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { convertTimestampToFormattedString } from "../../dateutils/date";
import StarIcon from "@mui/icons-material/Star";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import msg from "../../assets/chatui/msg.png";
import { useScrollbarVisibility } from "../../utils/useScrollbarVisibility";

import moment from "moment/moment";
import CloseIcon from "@mui/icons-material/Close";
import { news, pin } from "./chatsvgs";
import NewsFeed from "./newsfeed";
import { eventBus } from "../../utils/eventBus";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getPracticeId, patientPhotoUrl, practiceFeatures } from "../../config/practice";
import { chatLocationLabel, useChatUserConfig } from "./chatLocation";
import {
  chatTabRows,
  chipTags,
  filterChatProfiles,
  keepSelectedChat,
  providerTagOptions,
  useChatListPoll,
} from "./callNotes";


const ChartList = ({
  setToggleScreen,
  isNewPatient,
  otherviews,
  setOtherViews,
  setIsNewPatient,
  setPatientId,
  selectedDate,
  setSelectedDate,
  patient,
  // OSA's Messaging page (features.messagingPage) owns the provider filter:
  // its dropdown sits in the page header, so the page passes the value and
  // setter, gets the options back through onProviderOptions, and gets the
  // unread count through setUnreadCount. Without them the list keeps its own
  // filter (Communication > Messaging, unchanged).
  selectedProvider: providerProp,
  setSelectedProvider: setProviderProp,
  onProviderOptions,
  setUnreadCount,
}) => {
  // const [selectedDate, setSelectedDate] = useState(dayjs());
  // Header location of this login: on "All", inbox rows name their location (11-04).
  const userConfig = useChatUserConfig();
  const [showCalendar, setShowCalendar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [suggestionsLoading, setSuggestionsLoading] = useState([]);

  const [newpatientdata, setNewPatientData] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [filteredprofiles, setFilteredProfiles] = useState([]);
  const [selectedSuggestions, setSelectedSuggestions] = useState([]);
  const [searchquery, setSearchQuery] = useState("");
  const [isFetching, setIsFetching] = useState(false); // Track if loading more profiles
  const [expanded, setExpanded] = useState(0);
  const debounceTimeout = useRef(null);
  const practiseid = getPracticeId();

  // Refs for scrollable areas
  const unreadScrollRef = useRef(null);
  const starredScrollRef = useRef(null);
  const allScrollRef = useRef(null);
  const newPatientScrollRef = useRef(null);

  // Scrollbar visibility hook
  const { setupScrollListener } = useScrollbarVisibility();
  const isToday = (date) => {
    const today = new Date();
    const checkDate = new Date(date);
    return (
      today.getDate() === checkDate.getDate() &&
      today.getMonth() === checkDate.getMonth() &&
      today.getFullYear() === checkDate.getFullYear()
    );
  };
  const [selectedFilter, setSelectedFilter] = useState("unread");
  // Call notes (7825): OSA's list -- provider filter, its own tag chips, no
  // jump to the first conversation, a 60-second poll (fax/chat/callNotes.js).
  const callNotes = practiceFeatures().callNotes;
  const [ownProvider, setOwnProvider] = useState("");
  const providerControlled = typeof setProviderProp === "function";
  const selectedProvider = providerControlled ? providerProp || "" : ownProvider;
  const setSelectedProvider = providerControlled ? setProviderProp : setOwnProvider;
  const tabPickedRef = useRef(false);
  const pollTickRef = useRef(null);
  const fetchData = async (date, query) => {
    try {
      setLoading(true);
      const payload = {
        cdate: date || selectedDate.format("YYYY-MM-DD"),
      };

      if (query) {
        payload.lookup = query;
      } else {
        delete payload.lookup;
      }

      const response = await api.post(
        `/v1/${practiseid}/messaging/chatmaster`,
        payload
      );
      if (response.status == 200) {
        setProfiles(response?.data || []);
      } else {
        setProfiles([]);
      }
    } catch (error) {
      setProfiles([]);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const loadData = async () => {
    try {
      const response = await api.post(
        `/v1/${practiseid}/messaging/chatmaster`,
        {
          cdate: selectedDate.format("YYYY-MM-DD"),
        }
      );
      if (response.status == 200) {
        setProfiles(response?.data || []);
      } else {
        setProfiles([]);
      }
    } catch (error) {
      setProfiles([]);
      console.log(error);
    } finally {
    }
  };
useEffect(() => {
    // Listen when other components request a refresh
    eventBus.on("REFRESH_CHAT_LIST", loadData);

    // Cleanup to avoid memory leaks
    return () => {
      eventBus.off("REFRESH_CHAT_LIST", loadData);
    };
  }, []);
  // The poll's tick, rebuilt every render so it sees the search box and date
  // as they are now: nothing is re-read while a search is typed or the New
  // Patient list is open.
  useEffect(() => {
    pollTickRef.current = () => {
      if (searchquery || isNewPatient) return;
      loadData();
    };
  });
  useChatListPoll(callNotes, pollTickRef);
  const loadsuggetions = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/messaging/tags`);
      if (response.status === 200) {
        setSuggestions(response.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSuggestionsLoading(false);
    }
  };

  const handleDateChange = (date) => {
    const dayjsDate = dayjs(date);
    setSelectedDate(dayjsDate);
    fetchData(dayjsDate.format("YYYY-MM-DD"));
    setShowCalendar(false);
    setSearchQuery('')
  };
  const fetchNewpatients = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/v1/${practiseid}/patient/new-patients`);
      if (response.status === 200) {
        setNewPatientData(response.data);
      } else {
        setNewPatientData([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const makeChatfav = async (x, y) => {
    try {
      await api.put(`/v1/${practiseid}/messaging/${x}/chatfav`, {
        isfavorite: y,
      });
    } catch (error) {
      console.error(error);
    } finally {
      if (searchquery) {
        fetchData(false, searchquery);
      } else {
        loadData();
      }
    }
  };

  const makeChatstatus = async (x, y) => {
    try {
      await api.put(`/v1/${practiseid}/messaging/${x}/chatstatus`, {
        isdone: y,
      });
    } catch (error) {
      console.error(error);
    } finally {
      if (searchquery) {
        fetchData(false, searchquery);
      } else {
        loadData();
      }
    }
  };

  const handleScroll = (e) => {
    if (
      e.target.scrollTop + e.target.clientHeight >=
        e.target.scrollHeight - 10 &&
      !isFetching
    ) {
      setIsFetching(true);
    }
  };

  useEffect(() => {
    fetchData(false, false);
    loadsuggetions();
  }, []);

  // Set up scroll listeners for scrollbar visibility
  useEffect(() => {
    const cleanupUnread = setupScrollListener(unreadScrollRef.current);
    const cleanupStarred = setupScrollListener(starredScrollRef.current);
    const cleanupAll = setupScrollListener(allScrollRef.current);
    const cleanupNewPatient = setupScrollListener(newPatientScrollRef.current);

    return () => {
      cleanupUnread?.();
      cleanupStarred?.();
      cleanupAll?.();
      cleanupNewPatient?.();
    };
  }, [setupScrollListener]);
  useEffect(() => {
    setFilteredProfiles(profiles);
  }, [profiles]);

  useEffect(() => {
    if(otherviews==='newsfeed')return
    if (callNotes) {
      // Keep the conversation on screen (its row refreshed); never open the
      // first one by itself.
      const kept = keepSelectedChat(patient, profiles);
      if (kept !== patient) setPatientId(kept);
      return;
    }
    if (isNewPatient && newpatientdata && newpatientdata.length > 0) {
      const reversed = [...newpatientdata].reverse();
      setPatientId({ ...reversed[0], flow: "" });
      return;
    }

    if (profiles && profiles.length > 0) {
      const unread = profiles.filter(
        (x) => x.unread_v2 === 1 && x.is_reply === 0
      );
      const all = profiles.filter(
        (x) =>
          !(x.unread_v2 === 0 && x.is_favorite === 1) &&
          !(x.unread_v2 === 1 && x.is_reply === 0)
      );
      const starred = profiles.filter(
        (x) => x.is_favorite === 1 && x.unread_v2 === 0
      );

      const filterOrder = {
        unread: [unread, all, starred],
        all: [all, unread, starred],
        starred: [starred, unread, all],
      };

      const preferredList = filterOrder[selectedFilter];

      let matchedPatient = null;

      for (const list of preferredList) {
        const matchingProfiles = list.filter((profile) => {
          if (!selectedSuggestions || selectedSuggestions.length === 0)
            return true;

          const profileTags = profile.tags
            ? profile.tags.split(",").map((tag) => tag.trim().toLowerCase())
            : [];

          return selectedSuggestions.some((selected) =>
            profileTags.includes(selected.toLowerCase())
          );
        });

        if (matchingProfiles.length > 0) {
          matchedPatient = { ...matchingProfiles[0], flow: "" };
          break;
        }
      }

      setPatientId(matchedPatient || {});
    }
  }, [
    profiles,
    selectedFilter,
    isNewPatient,
    newpatientdata,
    selectedSuggestions,
  ]);

  // useEffect(() => {
  //     if (isNewPatient && newpatientdata && newpatientdata.length > 0) {
  //     const reversed = [...newpatientdata].reverse();
  //     setPatientId({ ...reversed[0], flow: '' });
  //     return; // Exit early so it doesn't continue to the other logic
  //   }
  //   if (profiles && profiles.length > 0) {
  //     const unread = profiles.filter(
  //       x => x.unread_v2 === 1 && x.is_reply === 0
  //     );
  //     const all = profiles.filter(
  //       x => !(x.unread_v2 === 0 && x.is_favorite === 1) &&
  //            !(x.unread_v2 === 1 && x.is_reply === 0)
  //     );
  //     const starred = profiles.filter(
  //       x => x.is_favorite === 1 && x.unread_v2 === 0
  //     );

  //     const filterOrder = {
  //       unread: [unread, all, starred],
  //       all: [all, unread, starred],
  //       starred: [starred, unread, all],
  //     };

  //     const preferredList = filterOrder[selectedFilter];
  // console.log(selectedSuggestions)
  //     for (const list of preferredList) {
  //       if (list.length > 0) {
  //         setPatientId({ ...list[0], flow: '' });
  //         break;
  //       }
  //     }
  //     // else do nothing if all are empty
  //   }
  // }, [profiles, selectedFilter,isNewPatient,newpatientdata,selectedSuggestions ]);

  const handleSearch = (query) => {
    if (isNewPatient) {
      setIsNewPatient(false);
    }
    setSearchQuery(query);

    // If query is empty, reset profiles and fetch initial data
    if (!query.trim()) {
      // Clear any existing debounce timeout
      clearTimeout(debounceTimeout.current);

      // Immediately fetch initial data
      fetchData(false, "");
      return;
    }

    // Clear any existing debounce timeout
    clearTimeout(debounceTimeout.current);

    // Set a new debounce timeout
    debounceTimeout.current = setTimeout(() => {
      fetchData(false, query);
    }, 2000); // 2-second delay
  };
  const handleSelect = (suggestion) => {
    setSelectedSuggestions((prevSelected) => {
      // If suggestion is already selected, remove it, else add it
      if (prevSelected.includes(suggestion)) {
        return prevSelected.filter((item) => item !== suggestion);
      } else {
        return [...prevSelected, suggestion];
      }
    });
  };
  useEffect(() => {
    // Call notes: pick the opening tab once, not again on every poll.
    if (callNotes) {
      if (tabPickedRef.current || !filteredprofiles?.length) return;
      tabPickedRef.current = true;
    }
    if (
      filteredprofiles?.filter((x) => x.unread_v2 === 1 && x.is_reply === 0)
        .length
    ) {
      setSelectedFilter("unread");
      return;
    } else if (
      filteredprofiles.filter((x) => x.is_favorite === 1 && x.unread_v2 === 0)
        .length
    ) {
      setSelectedFilter("starred");
      return;
    } else if (
      filteredprofiles.filter(
        (x) =>
          !(x.unread_v2 === 0 && x.is_favorite === 1) && // Not Starred
          !(x.unread_v2 === 1 && x.is_reply === 0) // Not Unread
      ).length
    ) {
      setSelectedFilter("all");
      return;
    }
  }, [filteredprofiles]);
  // Wait until selectedSuggestions is updated
  useEffect(() => {
    if (callNotes) {
      setFilteredProfiles(
        filterChatProfiles(profiles, { tags: selectedSuggestions, provider: selectedProvider })
      );
      return;
    }
    if (selectedSuggestions.length === 0) {
      setFilteredProfiles(profiles);
    } else {
      setFilteredProfiles(
        profiles.filter(
          (profile) =>
            typeof profile.tags === "string" &&
            selectedSuggestions.some((suggestion) =>
              profile.tags.includes(suggestion)
            )
        )
      );
    }
  }, [selectedSuggestions, profiles, selectedProvider]);
  const formatDate = (dateString) => {
    return dayjs(dateString).format("MM/DD/YYYY");
  };
  const onChipdelete = async () => {
    setSelectedDate(dayjs());
    fetchData(moment().format("YYYY-MM-DD"));
  };
  // Unread / All / Starred rows (care's rule; OSA's for call notes).
  const tabRows = chatTabRows(filteredprofiles, {
    osa: callNotes,
    filtered: selectedSuggestions.length > 0 || Boolean(selectedProvider),
  });
  // The page header's dropdown options and unread count (OSA's page only).
  const providerOptionsKey = callNotes ? providerTagOptions(suggestions, profiles).join("\n") : "";
  useEffect(() => {
    if (onProviderOptions) onProviderOptions(providerOptionsKey ? providerOptionsKey.split("\n") : []);
  }, [providerOptionsKey]);
  const unreadRows = tabRows.unread.length;
  useEffect(() => {
    if (setUnreadCount) setUnreadCount(unreadRows);
  }, [unreadRows]);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false); // Toggle the expanded state
  };
  return (
    <>
      <div className="flex flex-col w-full h-full min-w-full gap-2.5 p-3 pt-3">
        {/* Search Bar */}
        <div className="w-full flex items-center gap-2">
          <div className="flex items-center flex-1 h-[38px] bg-[#F7F9FB] pl-3.5 gap-2 border border-[#E5E7EB] rounded-xl shadow-sm hover:border-[#C5C8CE] transition-colors focus-within:border-[#1D2951] focus-within:shadow-md">
            <FontAwesomeIcon icon={faSearch} className="text-[#9CA3AF] h-3.5" />
            <input
              type="text"
              className="flex-grow bg-transparent py-1 h-[37px] pl-1 text-[13px] outline-none text-[#1D2951] placeholder:text-[#B0B7C3]"
              placeholder="Search..."
              value={searchquery}
              onChange={(e) => handleSearch(e.target.value)}
            />
            {searchquery && (
              <IconButton
                size="small"
                onClick={() => handleSearch("")}
                sx={{
                  marginRight: "0.5rem",
                  "&:focus": { outline: "none" },
                }}
              >
                <CloseIcon sx={{ fontSize: 16, color: "#9CA3AF" }} />
              </IconButton>
            )}
          </div>

          {!isToday(selectedDate) && (
            <Chip
              label={formatDate(selectedDate)}
              onDelete={() => onChipdelete()}
              color="primary"
              variant="outlined"
              size="small"
              sx={{ fontSize: 11, height: 28 }}
            />
          )}

          <div
            onClick={() => setShowCalendar(!showCalendar)}
            className="w-[38px] h-[38px] flex items-center justify-center rounded-xl border border-[#E5E7EB] bg-white shadow-sm cursor-pointer hover:bg-[#F9FAFB] hover:border-[#C5C8CE] transition-all"
          >
            <img
              src={calendericon}
              className="h-[18px] w-[18px]"
              alt="calendar icon"
            />
          </div>
        </div>

        {/* Provider filter (call notes, 7825): the provider tags. */}
        {callNotes && !providerControlled && providerTagOptions(suggestions, profiles).length > 0 && (
          <select
            aria-label="Filter by provider"
            value={selectedProvider}
            onChange={(e) => setSelectedProvider(e.target.value)}
            className="w-full h-[32px] px-2 text-[12px] font-inter text-[#1D2951] bg-white border border-[#E5E7EB] rounded-xl focus:outline-none"
          >
            <option value="">All Providers</option>
            {providerTagOptions(suggestions, profiles).map((tag) => (
              <option key={tag} value={tag}>
                {tag}
              </option>
            ))}
          </select>
        )}
        {/* Tags Row */}
        <div className="w-full flex gap-2 overflow-x-auto flex-nowrap min-h-[32px] items-center" style={{ scrollbarWidth: "none", WebkitOverflowScrolling: "touch" }}>
          {suggestionsLoading && loading ? (
            Array.from({ length: 4 }).map((_, index) => <div key={index}></div>)
          ) : (
            <>
              {suggestions.length > 0 &&
                !isNewPatient &&
                (callNotes ? chipTags(suggestions, profiles) : suggestions).map((suggestion, index) => (
                  <button
                    key={index}
                    className={`rounded-full h-[28px] px-3.5 text-[12px] font-medium font-inter whitespace-nowrap flex-shrink-0 transition-all duration-200 border inline-flex items-center ${
                      selectedSuggestions.includes(suggestion)
                        ? "bg-[#1D2951] text-white border-[#1D2951] shadow-sm"
                        : "bg-[#F9FAFB] text-[#374151] border-[#D1D5DB] hover:bg-[#F3F4F6] hover:border-[#9CA3AF]"
                    }`}
                    onClick={() => handleSelect(suggestion)}
                  >
                    {suggestion?.charAt(0).toUpperCase() + suggestion?.slice(1)}
                  </button>
                ))}
              {/* No New Patient list on call notes (7825). */}
              {!callNotes && (
              <div className="flex items-center gap-1 flex-shrink-0">
                <button
                  onClick={() => {
                    if (isNewPatient) {
                      setIsNewPatient(false);
                    } else {
                      setIsNewPatient(true);
                      fetchNewpatients();
                    }
                  }}
                  className={`rounded-full font-inter h-[28px] px-3.5 text-[12px] font-medium whitespace-nowrap transition-all duration-200 border inline-flex items-center ${
                    isNewPatient
                      ? "bg-[#1D2951] text-white border-[#1D2951] shadow-sm"
                      : "bg-[#F9FAFB] text-[#374151] border-[#D1D5DB] hover:bg-[#F3F4F6] hover:border-[#9CA3AF]"
                  }`}
                >
                  New Patient
                </button>
                {isNewPatient && (
                  <CloseIcon
                    onClick={() => setIsNewPatient(false)}
                    className="cursor-pointer text-[#1D2951] hover:text-red-600"
                    sx={{ fontSize: 16 }}
                    aria-label="Cancel New Patient"
                  />
                )}
              </div>
              )}
            </>
          )}
        </div>

        {/* Filter Tabs - Segmented Control */}
        {!isNewPatient ? (
          <div className="rounded-xl bg-[#F3F4F6] flex w-full p-1 text-[12px] font-medium">
            {[
              { key: "unread", label: "Unread", count: tabRows.unread.length },
              { key: "all", label: "All", count: tabRows.all.length },
              { key: "starred", label: "Starred", count: tabRows.starred.length },
            ].map((tab) => (
              <div
                key={tab.key}
                className={`flex-1 text-center cursor-pointer py-[6px] rounded-lg transition-all duration-200 ${
                  selectedFilter === tab.key
                    ? "bg-white text-[#1D2951] shadow-sm font-semibold"
                    : "text-[#9CA3AF] hover:text-[#6B7280]"
                }`}
                onClick={() => setSelectedFilter(tab.key)}
              >
                {tab.label}
                {!loading && ` (${tab.count})`}
              </div>
            ))}
          </div>
        ) : null}

        {!isNewPatient ? (
          <div
            className="flex flex-col w-full gap-0 overflow-y-auto sm:max-h-[70vh]"
          >
           {/* News Feed Card (none on call notes, 7825) */}
           {!callNotes && (
           <div className={`mx-1 mb-2 rounded-xl cursor-pointer transition-all duration-200 ${otherviews==='newsfeed'
        ? "bg-[#1D2951] shadow-md"
        : "bg-white hover:bg-[#F9FAFB] border border-[#F1F3F9]"
    }`} onClick={() => {
      setPatientId({})
               setOtherViews('newsfeed')
              }}>
    <div className="flex items-center justify-between px-3 py-2.5">
      <div className="flex items-center gap-2.5">
        <div className="h-9 w-9 rounded-xl bg-[#166FF6] flex items-center justify-center flex-shrink-0 shadow-sm">
          {news}
        </div>
        <div className="flex flex-col">
          <span className={`${otherviews==='newsfeed' ? "text-white" : "text-[#1D2951]"} text-[13px] font-semibold`}>News Feed</span>
          <span className={`${otherviews==='newsfeed' ? "text-blue-200" : "text-[#9CA3AF]"} text-[10px]`}>Latest updates</span>
        </div>
      </div>
      <div className="flex items-center gap-1.5">
        <span className={`text-[10px] ${otherviews==='newsfeed' ? "text-blue-200" : "text-[#B0B7C3]"}`}>
          1 day ago
        </span>
        <div className={`${otherviews==='newsfeed' ? "text-blue-200" : "text-[#D1D5DB]"}`}>{pin}</div>
      </div>
    </div>
  </div>
           )}
            {selectedFilter === "unread" ? (
              <div className="w-full h-full flex flex-col">
                {loading ? (
                  <div className="flex flex-col h-auto gap-2 px-1">
                    {[...Array(8)].map((_, index) => (
                      <Skeleton
                        key={index}
                        variant="rectangular"
                        height={56}
                        sx={{ borderRadius: "12px" }}
                      />
                    ))}
                  </div>
                ) : tabRows.unread?.length ==
                  0 ? (
                  <div className="flex flex-col justify-center items-center py-12 text-[#9CA3AF]">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="mb-3 opacity-40">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span className="text-[13px]">No Patients Found</span>
                  </div>
                ) : (
                  <div
                    ref={unreadScrollRef}
                    className="h-auto pb-10 cursor-pointer px-1"
                    onScroll={handleScroll}
                  >
                    {tabRows.unread
                      .map((profile) => (
                        <div
                          key={profile.id}
                          className={`
    flex rounded-xl justify-between py-2.5 px-3 w-full items-center mb-1
    transition-all duration-200 cursor-pointer
    ${
      patient?.patientid !== profile.patientid
        ? "hover:bg-[#F5F7FA] bg-transparent"
        : "bg-[#1D2951] shadow-md"
    }
  `}
                          onClick={() => {
                              setOtherViews('')
                            setPatientId({ ...profile, flow: "" });
                            setToggleScreen(false);
                          }}
                        >
                          <div className="flex items-center gap-2.5 flex-1 min-w-0">
                            <div className="relative flex-shrink-0">
                              <img
                                src={patientPhotoUrl(profile.patientid)}
                                alt="profile"
                                onError={(e) =>
                                  (e.target.src =
                                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
                                }
                                className={`w-[38px] h-[38px] rounded-full object-cover ${
                                  patient?.patientid === profile.patientid ? "ring-2 ring-white/30" : "ring-2 ring-[#F1F3F9]"
                                }`}
                              />
                            </div>
                            <div className="flex flex-col min-w-0 flex-1">
                              <div className="flex items-center gap-1.5">
                                <span
                                  className={`text-[13px] font-semibold capitalize truncate ${
                                    patient?.patientid == profile?.patientid
                                      ? "text-white"
                                      : "text-[#1D2951]"
                                  }`}
                                  style={{ maxWidth: "140px" }}
                                >
                                  {profile.patientname}
                                </span>
                                {chatLocationLabel(profile, userConfig) && (
                                  <span
                                    data-testid="chat-location"
                                    className="ml-1 shrink-0 rounded px-1 text-[10px] leading-4 font-font1 bg-[#E8EEF7] text-[#24578F]"
                                  >
                                    {chatLocationLabel(profile, userConfig)}
                                  </span>
                                )}
                                <div className="flex gap-1 flex-nowrap flex-shrink-0">
                                  {profile.tags
                                    ? profile.tags.split(",").map((tag, index) => {
                                        const cleanTag = (tag || "").trim().toLowerCase();
                                        const formattedTag = cleanTag.charAt(0).toUpperCase() + cleanTag.slice(1);
                                        return (
                                          <span
                                            key={index}
                                            className={`px-1.5 py-[1px] rounded-full text-[9px] font-semibold ${
                                              patient?.patientid === profile.patientid
                                                ? "bg-white/20 text-white"
                                                : "bg-[#FFF0E6] text-[#E17954]"
                                            }`}
                                          >
                                            {formattedTag}
                                          </span>
                                        );
                                      })
                                    : null}
                                </div>
                              </div>
                              <div className="flex items-center gap-2 mt-0.5">
                                {profile.tags !== "newpt" && (
                                  <span className={`text-[11px] ${
                                    patient?.patientid == profile?.patientid ? "text-blue-200" : "text-[#9CA3AF]"
                                  }`}>
                                    #{profile.patientid}
                                  </span>
                                )}
                                <span className={`text-[11px] ${
                                  patient?.patientid == profile?.patientid ? "text-blue-200" : "text-[#B0B7C3]"
                                }`}>
                                  {convertTimestampToFormattedString(profile.ptts)}
                                </span>
                              </div>
                              {profile.is_locked && profile.locked_by && (
                                <span className="text-[#E17954] text-[10px] font-medium mt-0.5">
                                  {profile.locked_by} is Typing...
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="flex items-center gap-0.5 flex-shrink-0 ml-2">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                makeChatstatus(profile.patientid, profile.is_done ? 0 : 1);
                              }}
                              sx={{ padding: "4px", "&:focus": { outline: "none" } }}
                            >
                              <DoneIcon
                                sx={{ color: profile.is_done ? "#22C55E" : (patient?.patientid === profile.patientid ? "rgba(255,255,255,0.4)" : "#D1D5DB"), fontSize: 18 }}
                              />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                makeChatfav(profile.patientid, profile.is_favorite ? 0 : 1);
                              }}
                              sx={{ padding: "4px", "&:focus": { outline: "none" } }}
                            >
                              {profile.is_favorite ? (
                                <StarIcon sx={{ color: "#FACC15", fontSize: 18 }} />
                              ) : (
                                <StarBorderIcon sx={{ color: patient?.patientid === profile.patientid ? "rgba(255,255,255,0.4)" : "#D1D5DB", fontSize: 18 }} />
                              )}
                            </IconButton>
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            ) : selectedFilter === "starred" ? (
              <>
                {loading ? (
                  <div className="flex flex-col h-auto gap-2 px-1">
                    {[...Array(8)].map((_, index) => (
                      <Skeleton key={index} variant="rectangular" height={56} sx={{ borderRadius: "12px" }} />
                    ))}
                  </div>
                ) : tabRows.starred?.length == 0 ? (
                  <div className="flex flex-col justify-center items-center py-12 text-[#9CA3AF]">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="mb-3 opacity-40">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span className="text-[13px]">No Starred Patients</span>
                  </div>
                ) : (
                  <div ref={starredScrollRef} className="overflow-y-auto h-auto pb-10 cursor-pointer px-1" onScroll={handleScroll}>
                    {tabRows.starred
                      .map((profile) => (
                        <div key={profile.id} className={`flex rounded-xl justify-between py-2.5 px-3 w-full items-center mb-1 transition-all duration-200 cursor-pointer ${patient?.patientid !== profile.patientid ? "hover:bg-[#F5F7FA] bg-transparent" : "bg-[#1D2951] shadow-md"}`}
                          onClick={() => { setOtherViews(''); setPatientId({ ...profile, flow: "" }); setToggleScreen(false); }}
                        >
                          <div className="flex items-center gap-2.5 flex-1 min-w-0">
                            <div className="relative flex-shrink-0">
                              <img src={patientPhotoUrl(profile.patientid)} alt="profile"
                                onError={(e) => (e.target.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")}
                                className={`w-[38px] h-[38px] rounded-full object-cover ${patient?.patientid === profile.patientid ? "ring-2 ring-white/30" : "ring-2 ring-[#F1F3F9]"}`}
                              />
                            </div>
                            <div className="flex flex-col min-w-0 flex-1">
                              <div className="flex items-center gap-1.5">
                                <span className={`text-[13px] font-semibold capitalize truncate ${patient?.patientid == profile?.patientid ? "text-white" : "text-[#1D2951]"}`} style={{ maxWidth: "140px" }}>
                                  {profile.patientname}
                                </span>
                                {chatLocationLabel(profile, userConfig) && (
                                  <span
                                    data-testid="chat-location"
                                    className="ml-1 shrink-0 rounded px-1 text-[10px] leading-4 font-font1 bg-[#E8EEF7] text-[#24578F]"
                                  >
                                    {chatLocationLabel(profile, userConfig)}
                                  </span>
                                )}
                                <div className="flex gap-1 flex-nowrap flex-shrink-0">
                                  {profile.tags ? profile.tags.split(",").map((tag, index) => (
                                    <span key={index} className={`px-1.5 py-[1px] rounded-full text-[9px] font-semibold ${patient?.patientid === profile.patientid ? "bg-white/20 text-white" : "bg-[#FFF0E6] text-[#E17954]"}`}>{tag.trim()}</span>
                                  )) : null}
                                </div>
                              </div>
                              <div className="flex items-center gap-2 mt-0.5">
                                {profile.tags !== "newpt" && (
                                  <span className={`text-[11px] ${patient?.patientid == profile?.patientid ? "text-blue-200" : "text-[#9CA3AF]"}`}>#{profile.patientid}</span>
                                )}
                                <span className={`text-[11px] ${patient?.patientid == profile?.patientid ? "text-blue-200" : "text-[#B0B7C3]"}`}>{convertTimestampToFormattedString(profile.ptts)}</span>
                              </div>
                              {profile.is_locked && profile.locked_by && (
                                <span className="text-[#E17954] text-[10px] font-medium mt-0.5">{profile.locked_by} is Typing...</span>
                              )}
                            </div>
                          </div>
                          <div className="flex items-center gap-0.5 flex-shrink-0 ml-2">
                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); makeChatstatus(profile.patientid, profile.is_done ? 0 : 1); }} sx={{ padding: "4px", "&:focus": { outline: "none" } }}>
                              <DoneIcon sx={{ color: profile.is_done ? "#22C55E" : (patient?.patientid === profile.patientid ? "rgba(255,255,255,0.4)" : "#D1D5DB"), fontSize: 18 }} />
                            </IconButton>
                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); makeChatfav(profile.patientid, profile.is_favorite ? 0 : 1); }} sx={{ padding: "4px", "&:focus": { outline: "none" } }}>
                              {profile.is_favorite ? <StarIcon sx={{ color: "#FACC15", fontSize: 18 }} /> : <StarBorderIcon sx={{ color: patient?.patientid === profile.patientid ? "rgba(255,255,255,0.4)" : "#D1D5DB", fontSize: 18 }} />}
                            </IconButton>
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </>
            ) : (
              <>
                {loading ? (
                  <div className="flex flex-col h-auto gap-2 px-1">
                    {[...Array(8)].map((_, index) => (
                      <Skeleton key={index} variant="rectangular" height={56} sx={{ borderRadius: "12px" }} />
                    ))}
                  </div>
                ) : tabRows.all?.length == 0 ? (
                  <div className="flex flex-col justify-center items-center py-12 text-[#9CA3AF]">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="mb-3 opacity-40">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="9" cy="7" r="4" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span className="text-[13px]">No Patients Found</span>
                  </div>
                ) : (
                  <div ref={allScrollRef} className="overflow-y-auto h-auto pb-10 cursor-pointer px-1" onScroll={handleScroll}>
                    {tabRows.all
                      .map((profile) => (
                        <div key={profile.id} className={`flex rounded-xl justify-between py-2.5 px-3 w-full items-center mb-1 transition-all duration-200 cursor-pointer ${patient?.patientid !== profile.patientid ? "hover:bg-[#F5F7FA] bg-transparent" : "bg-[#1D2951] shadow-md"}`}
                          onClick={() => { setOtherViews(''); setPatientId({ ...profile, flow: "" }); setToggleScreen(false); }}
                        >
                          <div className="flex items-center gap-2.5 flex-1 min-w-0">
                            <div className="relative flex-shrink-0">
                              <img src={patientPhotoUrl(profile.patientid)} alt="profile"
                                onError={(e) => (e.target.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")}
                                className={`w-[38px] h-[38px] rounded-full object-cover ${patient?.patientid === profile.patientid ? "ring-2 ring-white/30" : "ring-2 ring-[#F1F3F9]"}`}
                              />
                            </div>
                            <div className="flex flex-col min-w-0 flex-1">
                              <div className="flex items-center gap-1.5">
                                <span className={`text-[13px] font-semibold capitalize truncate ${patient?.patientid == profile?.patientid ? "text-white" : "text-[#1D2951]"}`} style={{ maxWidth: "140px" }}>
                                  {profile.patientname}
                                </span>
                                {chatLocationLabel(profile, userConfig) && (
                                  <span
                                    data-testid="chat-location"
                                    className="ml-1 shrink-0 rounded px-1 text-[10px] leading-4 font-font1 bg-[#E8EEF7] text-[#24578F]"
                                  >
                                    {chatLocationLabel(profile, userConfig)}
                                  </span>
                                )}
                                <div className="flex gap-1 flex-nowrap flex-shrink-0">
                                  {profile.tags ? profile.tags.split(",").map((tag, index) => (
                                    <span key={index} className={`px-1.5 py-[1px] rounded-full text-[9px] font-semibold ${patient?.patientid === profile.patientid ? "bg-white/20 text-white" : "bg-[#FFF0E6] text-[#E17954]"}`}>{tag.trim()}</span>
                                  )) : null}
                                </div>
                              </div>
                              <div className="flex items-center gap-2 mt-0.5">
                                {profile.tags !== "newpt" && (
                                  <span className={`text-[11px] ${patient?.patientid == profile?.patientid ? "text-blue-200" : "text-[#9CA3AF]"}`}>#{profile.patientid}</span>
                                )}
                                <span className={`text-[11px] ${patient?.patientid == profile?.patientid ? "text-blue-200" : "text-[#B0B7C3]"}`}>{convertTimestampToFormattedString(profile.ptts)}</span>
                              </div>
                              {profile.is_locked && profile.locked_by && (
                                <span className="text-[#E17954] text-[10px] font-medium mt-0.5">{profile.locked_by} is Typing...</span>
                              )}
                            </div>
                          </div>
                          <div className="flex items-center gap-0.5 flex-shrink-0 ml-2">
                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); makeChatstatus(profile.patientid, profile.is_done ? 0 : 1); }} sx={{ padding: "4px", "&:focus": { outline: "none" } }}>
                              <DoneIcon sx={{ color: profile.is_done ? "#22C55E" : (patient?.patientid === profile.patientid ? "rgba(255,255,255,0.4)" : "#D1D5DB"), fontSize: 18 }} />
                            </IconButton>
                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); makeChatfav(profile.patientid, profile.is_favorite ? 0 : 1); }} sx={{ padding: "4px", "&:focus": { outline: "none" } }}>
                              {profile.is_favorite ? <StarIcon sx={{ color: "#FACC15", fontSize: 18 }} /> : <StarBorderIcon sx={{ color: patient?.patientid === profile.patientid ? "rgba(255,255,255,0.4)" : "#D1D5DB", fontSize: 18 }} />}
                            </IconButton>
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </>
            )}
          </div>
        ) : (
          <>
            {loading ? (
              <div className="flex flex-col h-auto gap-2 px-1">
                {[...Array(8)].map((_, index) => (
                  <Skeleton key={index} variant="rectangular" height={56} sx={{ borderRadius: "12px" }} />
                ))}
              </div>
            ) : (
              <div
                ref={newPatientScrollRef}
                className="sm:max-h-[80vh] w-full overflow-y-auto h-auto cursor-pointer px-1"
                style={{ scrollbarWidth: "none" }}
                onScroll={handleScroll}
              >
                {[...newpatientdata].reverse().map((profile) => (
                  <div
                    key={profile.id}
                    className="flex rounded-xl hover:bg-[#F5F7FA] justify-between py-2.5 px-3 w-full items-center mb-1 transition-all duration-200 cursor-pointer"
                    onClick={() => {
                      setOtherViews('')
                      setPatientId({ ...profile, flow: "newpt" });
                      setToggleScreen(false);
                    }}
                  >
                    <div className="flex items-center gap-2.5 flex-1 min-w-0">
                      <div className="w-[38px] h-[38px] rounded-full bg-[#F3F4F6] flex items-center justify-center flex-shrink-0 ring-2 ring-[#F1F3F9]">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                          <circle cx="12" cy="7" r="4"/>
                        </svg>
                      </div>
                      <div className="flex flex-col min-w-0 flex-1">
                        <div className="flex items-center gap-1.5">
                          <span className="text-[13px] font-semibold capitalize truncate text-[#1D2951]" style={{ maxWidth: "140px" }}>
                            {`${profile.firstname} ${profile.lastname}`}
                          </span>
                          <span className="px-1.5 py-[1px] rounded-full text-[9px] font-semibold bg-[#E17954] text-white flex-shrink-0">
                            New pt
                          </span>
                        </div>
                        <span className="text-[11px] text-[#B0B7C3] mt-0.5">
                          {convertTimestampToFormattedString(profile.ts)}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>

      {showCalendar && (
        <div
          className="absolute top-[45px] left-[100px] right-0 z-50"
          style={{ maxWidth: "300px" }}
        >
          <DatePicker
            selected={selectedDate.toDate()}
            onChange={handleDateChange}
            inline
            calendarClassName="custom-calendar"
            showMonthDropdown
            showYearDropdown
            yearDropdownItemNumber={15}
            dateFormat="MM/dd/yyyy"
          />
          <style>{`
            .custom-calendar {
              background-color: white;
              border-radius: 10px;
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              padding: 16px;
              font-family: inherit;
              width: 100%;
            }
            .custom-calendar .react-datepicker__header {
              background-color: white;
              border-bottom: none;
              padding: 0 0 12px 0;
            }
            .custom-calendar .react-datepicker__current-month {
              font-size: 15px;
              font-weight: 500;
              color: #1D2951;
              margin-bottom: 0;
              padding-bottom: 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 20px !important;
            }
            .custom-calendar .react-datepicker__current-month select {
              appearance: none;
              -webkit-appearance: none;
              -moz-appearance: none;
              background: white;
              border: none;
              font-size: 15px;
              font-weight: 500;
              color: #1D2951;
              cursor: pointer;
              padding-right: 28px;
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%231D2951' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
              background-repeat: no-repeat;
              background-position: right center;
              background-size: 10px 6px;
              outline: none;
            }
            .custom-calendar .react-datepicker__current-month select:focus,
            .custom-calendar .react-datepicker__current-month select:active,
            .custom-calendar .react-datepicker__current-month select:hover {
              outline: none;
              box-shadow: none;
              color: #1D2951;
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%231D2951' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
            }
            .custom-calendar .react-datepicker__month-dropdown-container,
            .custom-calendar .react-datepicker__year-dropdown-container {
              display: inline-block;
            }
            .custom-calendar .react-datepicker__month-dropdown,
            .custom-calendar .react-datepicker__year-dropdown {
              background-color: white;
              border: 1px solid #e5e7eb;
              border-radius: 6px;
              padding: 4px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
              max-height: 200px;
              overflow-y: auto;
            }
            .custom-calendar .react-datepicker__month-option,
            .custom-calendar .react-datepicker__year-option {
              padding: 6px 12px;
              cursor: pointer;
              font-size: 14px;
              border-radius: 4px;
              outline: none;
            }
            .custom-calendar .react-datepicker__month-option:focus,
            .custom-calendar .react-datepicker__year-option:focus {
              outline: none;
              box-shadow: none;
            }
            .custom-calendar .react-datepicker__month-option:hover,
            .custom-calendar .react-datepicker__year-option:hover {
              background-color: #f3f4f6;
            }
            .custom-calendar .react-datepicker__month-option--selected,
            .custom-calendar .react-datepicker__year-option--selected {
              background-color: #1D2951;
              color: white;
            }
            .custom-calendar .react-datepicker__day-names {
              display: flex;
              justify-content: space-around;
              margin-bottom: 8px;
              padding-top: 8px;
            }
            .custom-calendar .react-datepicker__day-name {
              width: 36px;
              line-height: 36px;
              margin: 0;
              color: #6b7280;
              font-size: 12px;
              font-weight: 500;
              text-align: center;
            }
            .custom-calendar .react-datepicker__month {
              margin: 0;
              padding: 0;
            }
            .custom-calendar .react-datepicker__week {
              display: flex;
              justify-content: space-around;
              margin-bottom: 4px;
            }
            .custom-calendar .react-datepicker__day {
              width: 34px;
              height: 34px;
              line-height: 36px;
              margin: 0;
              border-radius: 50%;
              color: #111827;
              font-size: 14px;
              transition: all 0.2s;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .custom-calendar .react-datepicker__day:hover {
              background-color: #f3f4f6;
              border-radius: 50%;
            }
            .custom-calendar .react-datepicker__day--selected,
            .custom-calendar .react-datepicker__day--keyboard-selected {
              background-color: #1D2951 !important;
              color: white !important;
              border-radius: 50%;
              font-weight: 500;
            }
            .custom-calendar .react-datepicker__day--selected:hover,
            .custom-calendar .react-datepicker__day--keyboard-selected:hover {
              background-color: #1D2951 !important;
            }
            .custom-calendar .react-datepicker__day--today {
              font-weight: 600;
              border: 1px solid #1D2951;
              border-radius: 50%;
              box-sizing: border-box;
            }
            .custom-calendar .react-datepicker__day--today.react-datepicker__day--selected,
            .custom-calendar .react-datepicker__day--today.react-datepicker__day--keyboard-selected {
              border-color: #1D2951;
              border-radius: 50%;
            }
            .custom-calendar .react-datepicker__day--outside-month {
              color: #d1d5db;
            }
            .custom-calendar .react-datepicker__navigation {
              top: 16px;
              outline: none;
              width: 32px;
              height: 32px;
              border-radius: 4px;
            }
            .custom-calendar .react-datepicker__navigation:hover {
              background-color: #f3f4f6;
            }
            .custom-calendar .react-datepicker__navigation:focus {
              outline: none;
              box-shadow: none;
            }
            .custom-calendar .react-datepicker__navigation--previous {
              left: 8px;
            }
            .custom-calendar .react-datepicker__navigation--next {
              right: 8px;
            }
            .custom-calendar .react-datepicker__navigation-icon::before {
              border-color: #111827;
              border-width: 2px 2px 0 0;
            }
          `}</style>
        </div>
      )}
    </>
  );
};

export default ChartList;
